import { z } from 'zod';
import { createTransformer } from './shared/base-api';
const findingMessageTemplatesSchema = z.record(z.string());
export const localeApiEndpoints = (builder, coreApiBaseUrl) => ({
    getLocale: builder.query({
        query: (language) => `${coreApiBaseUrl}/locales/${language}`,
        transformResponse: createTransformer(findingMessageTemplatesSchema, 'GetLocale'),
    }),
});
